export default class TaskPic {
  openModalInviteByEmail(element, isPlanFreeOrLight, planName, isNewCompany = false){
    let companyType = InviteUserShare.getCompanyType(element);
    if (isNewCompany === 'true') {
      companyType = 'collaborators'
    }
    InviteUserShare.updateCompanyTypeText(companyType)
    if(companyType === 'collaborators' && isPlanFreeOrLight === 'true') {
      $('#modalShowRequestUpgradePlan').modal('show')
      return
    }
    const isShowListmember = $('#addPersonInChargeOfObject').attr('data-is-back-list-member')
    if (isShowListmember && isShowListmember === 'true') {
      $('#addPersonInChargeOfObject').attr('data-is-back-list-member', 'false')
    }
    $("#addPersonInChargeOfObject").modal('hide')
    $('#inviteByEmail').find('#add_new_email_permission').val('')
    $('#inviteByEmail').find('#permission_email').val('')
    $('#inviteByEmail').modal('show')
    $('.invite_email_error').html("")
    if (!!companyType) {
      const permissionType = companyType.slice(0, -1);
      let textCompanyType = ''
      if (companyType === 'collaborators') {
        textCompanyType = '新しい外部アカウントを招待する'
      } else if (companyType === 'clients') {
        textCompanyType = '新しい販売先アカウントを招待する'
      } else if (companyType === 'suppliers') {
        textCompanyType = '新しい仕入先アカウントを招待する'
      } else {
        textCompanyType = '新しいチームメンバーを招待します'
      }
      $('#inviteByEmail').find('#show-text-invite-by-type-company').text(textCompanyType);
      $("#inviteByEmail").find('#permission_type').val(permissionType)
      $("#inviteByEmail").find('#add_new_email_permission_type').val(permissionType)
      $("#inviteByEmail").find('#add_new_email_permission_type').addClass('d-none');
      $("#inviteByEmail").find('#permission_type_label').addClass('d-none');
    } else {
      $("#inviteByEmail").find('#add_new_email_permission_type').removeClass('d-none');
      $("#inviteByEmail").find('#permission_type_label').removeClass('d-none');
    }
  }

  openModalInviteMemberOfPartner(isPlanFreeOrLight, planName, nameCompany){
    const companyType = InviteUserShare.getCompanyType();
    InviteUserShare.updateCompanyTypeText(companyType)
    $('#inviteExistUserByEmail').find('#permission_type').val(companyType.slice(0, -1))

    if(companyType === 'collaborators' && isPlanFreeOrLight === 'true') {
      $('#modalShowRequestUpgradePlan').modal('show')
      return
    }

    const isShowListmember = $('#addPersonInChargeOfObject').attr('data-is-back-list-member')
    if (isShowListmember && isShowListmember === 'true') {
      $('#addPersonInChargeOfObject').attr('data-is-back-list-member', 'false')
    }

    const companyName = $('#addPersonInChargeOfObject').find('#js_select_company_invites_task option:selected').text();
    let result = companyName.match(/・([^（(]+)\s*[（(]/)?.[1];
    if (['', null, undefined].includes(result)) result = nameCompany;

    $('.invite_email_error').html("")
    $("#addPersonInChargeOfObject").modal('hide')
    $("#inviteExistUserByEmail").modal('show')
    $("#inviteExistUserByEmail").find('#show-name-company-when-invite').text(result + '　');
    $("#inviteExistUserByEmail").find('#permission_name').val('')
    $("#inviteExistUserByEmail").find('#permission_email').val('')
  }

  validateEmailBeforeInvite(popup_id, task_id, project_id) {
    let isSubmit = true
    let email = $(popup_id).find(".add_new_email_permission").val();
    let type = $(popup_id).find("#add_new_email_permission_type").val();
    let name = $(popup_id).find("#permission_name").val();
    let type_text = this._getTypeText(type);
    if(email == "") {
      isSubmit = false;
      $(popup_id).find(".invite_email_error").html("空白にはできません。")
    } else {
      if(/^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i.test(email)) {
        $(popup_id).find(".invite_email_error").html("")
      } else {
        isSubmit = false;
      $(popup_id).find(".invite_email_error").html(I18n.t('admin.attributes.email.invalid'))
      }
    }

    if($(popup_id).find("#add_new_email_permission_type")) {
      if(type == "") {
        isSubmit = false;
        $(popup_id).find(".invite_type_error").html("空白にはできません。")
      } else {
        $(popup_id).find(".invite_type_error").html("")
      }
    }

    if($(popup_id).find("#permission_name").length > 0) {
      if (name.length > 0 && Shared.checkValidationUserName(name)) {
        Popup.alert('「ご担当者名」に利用できない文字があります。<br>ご担当者名を変更してください。')
        isSubmit = false;
      }
    }

    if(isSubmit) {
      $('.preloader').fadeIn();
      $(popup_id).attr('data-is-show-list-member', 'false');
      $(popup_id).find(".button-submit").click()
    }
  }

  handleCheckAction(element) {
    const ele = $(element);
    if(ele.find("input").is(":checked")) {
      ele.find("input").prop("checked", false).trigger("change")
      ele.find(".check-view").remove()
      ele.parents('.show-list-member-for-page').removeAttr('is-new-add')
    } else {
      ele.find("input").prop("checked", true).trigger("change")
      if (ele.hasClass('old-invite')) {
        ele.append("<div class='check-view check-old'></div>")
      } else {
        ele.append("<div class='check-view check-red'></div>")
      }
      ele.parents('.show-list-member-for-page').attr('is-new-add', 'true')
    }
  }

  handleCheckRemoveUnapproveMember(element, project_id, task_id) {
    let user_name = $(element).parent().find(".t_name").text()
    let user_id = $(element).attr("data-user-id")
    Popup.confirm('', {
        description: `${user_name}さんを解除します。<br> よろしいですか？`,
        confirmText: 'OK',
        cancelBtn: 'false',
        success: () => {
          const url = Routes.owner_remove_member_unapprove_of_task_path(project_id, task_id)
          Shared.callAjax(url, {user_id: user_id}, 'json', 'post')
          .done(function(data) {
            if($('.list-user-invite-new').length) {
              var list_waiting_name = $('.list-waiting-permission').find('.list-permission-name').html()
              if(list_waiting_name.includes(`, ${data.user_name}`)) {
                $('.list-waiting-permission').find('.list-permission-name').html(list_waiting_name.replace(`, ${data.user_name}`, ''))
              } else {
                $('.list-waiting-permission').find('.list-permission-name').html(list_waiting_name.replace(data.user_name, ''))
              }
            }
            Popup.confirm('',{
              description: `${user_name}さんの <br> 招待を解除しました。`,
              confirmText: 'OK',
              cancelBtn: 'false',
              success: () => {
                Task.showHideSettingPic(project_id, task_id)
              }
            })
          })
          .fail(function(data) {
            Popup.confirm('',{
              description: 'false',
              confirmText: 'OK',
              cancelBtn: 'false',
            })
          })
        },
      }
    )
  }

  handleCheckRemoveUnapproveRequest(element, project_id, task_id, akaire_file_id = null) {
    let user_name = $(element).parent().find(".t_name").text()
    let request_id = $(element).attr("data-request-id")
    Popup.confirm('', {
        description: `${user_name}さんを解除します。<br> よろしいですか？`,
        confirmText: 'OK',
        cancelBtn: 'false',
        success: () => {
          const url = Routes.owner_remove_request_unapprove_of_task_path(project_id, task_id)
          Shared.callAjax(url, {request_id: request_id, akaire_file_id: akaire_file_id}, 'json', 'delete')
          .done(function(data) {
            if($('.list-user-invite-new').length) {
              var list_waiting_name = $('.list-waiting-permission').find('.list-permission-name').html()
              if(list_waiting_name.includes(`, ${data.user_name}`)) {
                $('.list-waiting-permission').find('.list-permission-name').html(list_waiting_name.replace(`, ${data.user_name}`, ''))
              } else {
                $('.list-waiting-permission').find('.list-permission-name').html(list_waiting_name.replace(data.user_name, ''))
              }
            }
            Popup.confirm('',{
              description: `${user_name}さんの <br> 招待を解除しました。`,
              confirmText: 'OK',
              cancelBtn: 'false',
              success: () => {
                Task.showHideSettingPic(project_id, task_id)
              }
            })
          })
          .fail(function(data) {
            Popup.confirm('',{
              description: 'false',
              confirmText: 'OK',
              cancelBtn: 'false',
            })
          })
        },
      }
    )
  }

  closeModalError(element_id) {
    $(`#${element_id}`).modal('hide');
    if($('#inviteByEmail').length) {
      $('#inviteByEmail').modal('show');
    } else {
      $('#addAuthority').modal('show');
    }
  }

  confirmCloseModalSettingMember(project_id = null, task_id = null) {
    const personInChargeModal = $("#personInChargeOfObject")
    const new_task = $("#personInChargeOfObject").attr("data-new-task") == 'true'
    const fromAfterCreateTask = personInChargeModal.attr("data-from-after-create-task") == 'true'

    if(fromAfterCreateTask) {
      this.refreshUrlAfterSetting()
      personInChargeModal.modal('hide')
      if($('#afterCreateTaskProjectModalFromTwoOptions').length) {
        $('#afterCreateTaskProjectModalFromTwoOptions').removeAttr('data-tm-parent-modal-id')
        $('#afterCreateTaskProjectModalFromTwoOptions').modal('show')
        if (typeof Task.syncAfterCreateTaskModalBackStack === 'function') {
          Task.syncAfterCreateTaskModalBackStack()
        }
      }
      return
    }

    if(new_task) {
      Popup.confirm(
        '<div>選択済みのメンバーはリセットされます。<br> 初期設定時のメンバーのみが招待されます。<br> キャンセルしてよろしいですか？</div>',
        {
          success: () => {
            if(project_id && task_id){
              const url = Routes.owner_send_mail_to_default_permission_of_task_path(project_id, task_id)
              Shared.callAjax(url, {}, 'json', 'post').done(() => {
                personInChargeModal.attr("data-member-setting-completed", 'true')
              })
            }
            this.refreshUrlAfterSetting()
            personInChargeModal.modal('hide');
          },
          cancel: () => {},
          confirmText: 'OK',
          cancelBtn: 'false',
          width: 'auto'
        }
      )
    } else {
      if($('#personInChargeOfObject').attr("data-is-change") == "true") {
        Popup.confirm(
          '<div>選択済みのメンバーはリセットされます。<br>キャンセルしてよろしいですか？</div>',
          {
            success: () => {
              this.refreshUrlAfterSetting()
              personInChargeModal.modal('hide');
            },
            cancel: () => {},
            confirmText: 'OK',
            cancelText: 'キャンセル',
            width: 'auto'
          }
        )
        $('.swal2-container').click(function(event){
          event.stopPropagation();
        });
      } else {
        this.refreshUrlAfterSetting()
        personInChargeModal.modal('hide')
      }
    }


  }

  _getTypeText(type) {
    if(type == "collaborator") {
      return '外部'
    } else if (type == 'client') {
      return '販売'
    } else if (type == 'supplier') {
      return '仕入'
    } else {
      return '自社'
    }
  }

  updateMemberPaginationWindow(scope) {
    const root = scope && scope.jquery ? scope[0] : scope;
    if (!root) return;

    const pageItems = Array.from(root.querySelectorAll('li.page-item.page-number[data-index]'));
    if (pageItems.length <= 6) return;

    const activeItem = root.querySelector('li.page-item.page-number.active[data-index]');
    const activePage = Number(activeItem?.getAttribute('data-index') || 1);
    const totalPages = pageItems.length;
    const leftGap = root.querySelector('.gap-left');
    const rightGap = root.querySelector('.gap-right');
    let visiblePages;

    if (activePage <= 4) {
      visiblePages = [1, 2, 3, 4, 5, totalPages];
    } else if (activePage >= totalPages - 3) {
      visiblePages = [1, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      visiblePages = [1, activePage - 1, activePage, activePage + 1, totalPages];
    }

    visiblePages = Array.from(new Set(visiblePages)).filter((page) => page >= 1 && page <= totalPages);

    pageItems.forEach((item) => {
      const page = Number(item.getAttribute('data-index'));
      item.classList.toggle('d-none', !visiblePages.includes(page));
    });

    const sortedPages = [...visiblePages].sort((a, b) => a - b);
    const needsLeftGap = sortedPages[1] && sortedPages[1] - sortedPages[0] > 1;
    const needsRightGap =
      sortedPages.length >= 2 &&
      sortedPages[sortedPages.length - 1] - sortedPages[sortedPages.length - 2] > 1;

    if (leftGap) leftGap.classList.toggle('d-none', !needsLeftGap);
    if (rightGap) rightGap.classList.toggle('d-none', !needsRightGap);

    if (sortedPages[1] && sortedPages[1] - sortedPages[0] === 2) {
      const missingPage = sortedPages[0] + 1;
      const item = root.querySelector(`li.page-item.page-number[data-index="${missingPage}"]`);
      if (item) item.classList.remove('d-none');
      if (leftGap) leftGap.classList.add('d-none');
    }

    if (
      sortedPages.length >= 2 &&
      sortedPages[sortedPages.length - 1] - sortedPages[sortedPages.length - 2] === 2
    ) {
      const missingPage = sortedPages[sortedPages.length - 1] - 1;
      const item = root.querySelector(`li.page-item.page-number[data-index="${missingPage}"]`);
      if (item) item.classList.remove('d-none');
      if (rightGap) rightGap.classList.add('d-none');
    }
  }

  prevPage(ele) {
    const modalEle = ele.closest('#personInChargeOfObject, .popup-list-permission');
    const ulEle = $(ele).parents('ul.pagination')
    const pageSelected = ulEle.find('li.active')
    const numberPage = Number(pageSelected.data('index'))
    if (numberPage <= 1) return
    pageSelected.removeClass('active')
    ulEle.find(`li[data-index="${numberPage - 1}"]`).addClass('active')
    if (!modalEle) return
    $(modalEle).find('div.show-list-member-for-page').css('display', 'none')
    $(modalEle).find(`div.show-list-member-for-page[data-page="${numberPage - 1}"]`).css('display', 'flex')
    this.updateMemberPaginationWindow(ulEle);
  }

  nextPage(ele, maxPage) {
    const modalEle = ele.closest('#personInChargeOfObject, .popup-list-permission');
    const ulEle = $(ele).parents('ul.pagination')
    const pageSelected = ulEle.find('li.active')
    const numberPage = Number(pageSelected.data('index'))
    if (numberPage === Number(maxPage)) return
    pageSelected.removeClass('active')
    ulEle.find(`li[data-index="${numberPage + 1}"]`).addClass('active')
    if (!modalEle) return
    $(modalEle).find('div.show-list-member-for-page').css('display', 'none')
    $(modalEle).find(`div.show-list-member-for-page[data-page="${numberPage + 1}"]`).css('display', 'flex')
    this.updateMemberPaginationWindow(ulEle);
  }

  selectPage(ele, page = null) {
    const modalEle = ele.closest('#personInChargeOfObject, .popup-list-permission');
    const ulEle = $(ele).parents('ul.pagination')
    const pageSelected = ulEle.find('li.active')
    pageSelected.removeClass('active')
    if (!page) {
      page = $(ele).attr('data-index')
    }
    ulEle.find(`li[data-index="${page}"]`).addClass('active')
    if (!modalEle) return
    $(modalEle).find('div.show-list-member-for-page').attr('style', 'display: none !important')
    $(modalEle).find(`div.show-list-member-for-page[data-page="${page}"]`).attr('style', 'display: flex !important')
    this.updateMemberPaginationWindow(ulEle);
  }

  async changeNumberPage(ele, totalObject=null, numberOfPage=null, parentElement = '#personInChargeOfObject') {
    const widthWindow = $(window).width()
    let modalEle = ele.closest(`div${parentElement}`)

    // iPad teleport fallback: If .filter-content is moved to document.body,
    // we follow _teleportOrigin (the original parent) to identify the correct modal container.
    if (!modalEle) {
      const teleportedModal = ele.closest('.filter-content');
      if (teleportedModal && teleportedModal._teleportOrigin) {
        modalEle = teleportedModal._teleportOrigin.closest(`div${parentElement}`);
      }
    }
    const allTr = modalEle.querySelectorAll('.tr.show-list-member-for-page');
    let selector = '.tr.show-list-member-for-page[is-showed="true"]';
    const showMemberAddEle = modalEle.querySelector('span.show-number-member-add');

    if (showMemberAddEle && showMemberAddEle.getAttribute('is-show') === 'true') {
      selector += '[is-new-add="true"]';
    }

    const listTr = modalEle.querySelectorAll(selector);
    numberOfPage ??= Number(ele.textContent.trim());
    totalObject = listTr.length
    const totalEle = Number(totalObject)
    const pagynate = await Shared.fetchPagynateWithJs(totalEle, numberOfPage)

    $(ele).parent().find('.option').removeClass('slted');
    $(ele).addClass('slted')
    $(modalEle).find('.show-number-of-page-js').html(numberOfPage)
    allTr.forEach(tr => {
      tr.removeAttribute('data-page');
      tr.style.display = 'none'
    });

    listTr.forEach((tr, index) => {
      const page = Math.floor(index / numberOfPage) + 1
      tr.setAttribute('data-page', page)
      tr.style.display = page === 1 ? '' : 'none'
    })
    const newPagy = await Shared.reRenderPagyNate(
      pagynate, 'TaskPic.prevPage(this)', 'TaskPic.selectPage(this)',
      `TaskPic.nextPage(this, '${pagynate}')`
    )
    const pagyContainer = modalEle.querySelector('#render-list-pagynate-of-member-project-author');
    if (pagyContainer) {
      pagyContainer.innerHTML = newPagy
      this.updateMemberPaginationWindow(pagyContainer);
    }
    SearchForm.selectFilterDisplay('hide', '.filter-content-number-record-task', event)
  }

  searchMemberByName(searchIcon, parentElement = '#personInChargeOfObject') {
    const modalEle = searchIcon.closest(`div${parentElement}`);
    const perPageSelection = modalEle.querySelector('.table-toolbar-member-add .show-number-of-page-js');
    const keyword = modalEle.querySelector('#searchInput').value.trim().toLowerCase();
    const rows = modalEle.querySelectorAll('.tr.show-list-member-for-page');

    rows.forEach((row) => {
      const nameCell = row.querySelector('.td.t_name')
      const nameText = nameCell ? nameCell.innerText.toLowerCase().trim() : ''
      const isMatched = keyword === '' || nameText.includes(keyword)
      row.setAttribute('is-showed', isMatched ? 'true' : 'false');
    })

    const perPage = Number(perPageSelection.textContent.trim())
    this.changeNumberPage(perPageSelection, null, perPage, parentElement);
  }

  showListNewAdd(ele, parentElement = '#personInChargeOfObject') {
    const modalEle = ele.closest(`div${parentElement}`);
    const perPageSelection = modalEle.querySelector('.table-toolbar-member-add .show-number-of-page-js');
    if ($(ele).attr('is-show') && $(ele).attr('is-show') === 'true') {
      $(ele).attr('is-show', 'false')
      const text = window.innerWidth <= 576 ? '名' : $(ele).data('text')
      const number = $(ele).attr('data-number')
      $(ele).text(`${number} ${text}`)
    } else {
      const textHide = window.innerWidth <= 576 ? '戻る' : $(ele).data('text-hide')
      $(ele).attr('is-show', 'true')
      $(ele).text(`${textHide}`)
    }

    const perPage = Number(perPageSelection.textContent.trim())
    this.changeNumberPage(perPageSelection, null, perPage, parentElement);
  }

  checkAllOrCancelCheckAllMember(ele, objectId, projectId, taskId) {
    const isCheckAllMember = $(ele).prop('checked')
    if (isCheckAllMember) {
      this._handleCheckAllMember(ele, objectId, projectId, taskId)
    } else {
      this._handleCancelCheckAllMember(ele, objectId, projectId, taskId)
    }
  }

  removeParam(key, sourceURL) {
    if (!sourceURL) {
      return;
    }

    let rtn = sourceURL.split("?")[0];
    let param;
    let params_arr = [];
    let queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (let i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
  }

  changePagynationLinks() {
    const array = $(document).find('.task-list-pagination').find('a.page-link').toArray()
    array.forEach(tagA => {
      let tagAUrl = $(tagA).attr('href')
      tagAUrl = this.removeParam("new_task", tagAUrl);
      tagAUrl = this.removeParam("task_id", tagAUrl);
      $(tagA).attr('href', tagAUrl)
    })
  }

  refreshUrlAfterSetting() {
    const currentUrl = window.location.href
    if(currentUrl.includes('new_task=true')) {
      let newUrl = this.removeParam("new_task", currentUrl);
      newUrl = this.removeParam("task_id", newUrl);
      window.history.pushState( '', '', newUrl);
      this.changePagynationLinks();
    }
  }

  async _handleCancelCheckAllMember(ele, objectId, projectId, taskId) {
    const userIds = []
    const listUserUncheck = $('#list-user-uncheck')
    await $('#show-table-list-member').find('div.t_invite').toArray().forEach(divEle => {
      const input = $(divEle).find('input').length > 0 ? $(divEle).find('input') : undefined
      if (input && input.prop('checked')) {
        $("#list-user-uncheck").val(`${listUserUncheck.val()}${$(divEle).find('input').val()},`)
        userIds.push($(divEle).find('input').val())
      }
    })

    let url
    let data
    if (taskId != '' && Number(taskId) > 0) {
      url = Routes.check_add_permission_to_ticket_with_list_memeber_owner_project_task_ticket_path(projectId, taskId)
      data = { ticket_id: objectId, user_ids: userIds, is_remove: true }
    } else {
      url = Routes.check_add_permission_to_task_with_list_memeber_owner_project_tasks_path(projectId)
      data = { task_id: objectId, user_ids: userIds, is_remove: true }
    }

    Shared.callAjax(url, data).done(function(data) {
      data.list_users_add.forEach(userId => {
        $("#personInChargeOfObject").attr('data-is-change', 'true')
        $(`input[data-user-id="${userId}"]`).first().prop('checked', false).trigger('change')
        $(`input[data-user-id="${userId}"]`).parents('div.t_invite').find("div.check-view").remove()
      })
    })
    Array.from($('div.check-view.check-red')).forEach(divEle => {
      const input = $(divEle).parents('div.td.t_invite').find('input[name="pic"]')
      input.prop('checked', false).trigger('change')
      $(divEle).remove()
    })
  }

  async _handleCheckAllMember(ele, objectId, projectId, taskId) {
    const userIds = []
    const listUserUncheck = $('#list-user-uncheck')
    await $('#show-table-list-member').find('div.t_invite').toArray().forEach(divEle => {
      const input = $(divEle).find('input').length > 0 ? $(divEle).find('input') : undefined
      $("#list-user-uncheck").val(listUserUncheck.val().replace(`${$(divEle).find('input').val()},`, ''));
      if (input && !input.prop('checked')) {
        userIds.push($(divEle).find('input').val())
      }
    })

    let url
    let data
    if (taskId != '' & Number(taskId) > 0) {
      url = Routes.check_add_permission_to_ticket_with_list_memeber_owner_project_task_ticket_path(projectId, taskId)
      data = { ticket_id: objectId, user_ids: userIds }
    } else {
      url = Routes.check_add_permission_to_task_with_list_memeber_owner_project_tasks_path(projectId)
      data = { task_id: objectId, user_ids: userIds }
    }

    Shared.callAjax(url, data).done(function(data) {
      data.list_users_add.forEach(userId => {
        $("#personInChargeOfObject").attr('data-is-change', 'true')
        $(`input[data-user-id="${userId}"]`).first().prop('checked', true).trigger('change')
        let parent = $(`input[data-user-id="${userId}"]`).parents('div.t_invite')
        if (parent.hasClass('old-invite')) {
          parent.append("<div class='check-view check-old'></div>")
        } else {
          parent.append("<div class='check-view check-red'></div>")
        }
      })
    })
  }
}
